import React, { useState } from 'react'
import { Button, Dropdown, Tooltip as AntdTooltip } from 'antd'
import getFileIcon from '../../../utils/getFileIcon'
import { removeFileExtension } from '../../../utils/removeFileExtension'
import AiStatusBadge from '../AiStatusBadge'
import AiLoadingOverlay from '../AiLoadingOverlay'
import FileActionsMenu from '../FileActionsMenu'
import Share_Shorts_Grid_View from '../../../../../../../assets/Share_Shorts_Grid_View_2.png'
import './FileCard.scss'
import { api } from '../../../../../../../services'
import { useTranslation } from 'react-i18next'

const isImage = item =>
  item.media_format === 'IMAGE' ||
  item.media_format === 'PEXEL_IMAGE' ||
  item.media_format === 'GIF' ||
  item.media_format === 'CERT' ||
  item.media_format === 'BADGE' ||
  item.media_format === 'AR_IMAGE'

const FileCard = ({
  item,
  selectedItems,
  onSelectionChange,
  onAction,
  user,
  orgUserList,
  defaultQuery,
  userId,
  isSuperAdmin,
  isAdmin,
  aiProcessingItems,
  setVersionFile,
  setVersionModalVisible,
  setManagePermissionsModalVisible,
  setAuitModal,
  hoveredItemId,
  setHoveredItemId,
  shouldShowCheckbox,
  isDownloadCenter
}) => {
  const [openDropdownId, setOpenDropdownId] = useState(null)

  const [downloadingMediaId, setDownloadingMediaId] = useState(null)

  const handleDownload = async id => {
    try {
      setDownloadingMediaId(id)

      const response = await api.library.download({ id })
      const { downloadble_link } = response.data

      // Create a hidden <a> element
      const link = document.createElement('a')
      link.href = downloadble_link
      link.download = '' // Leave empty to use filename from server or link
      link.style.display = 'none'
      document.body.appendChild(link)

      // Trigger the download
      link.click()

      // Clean up
      document.body.removeChild(link)
    } catch (error) {
      console.error('Download failed:', error)
    } finally {
      setDownloadingMediaId(null)
    }
  }
  const { t } = useTranslation()
  return (
    <div
      key={item.id}
      className={`file-card grid-file-card ${
        selectedItems.includes(item.id) ? 'selected' : ''
      }`}
      onClick={() => onAction && onAction('view', item)}
      onMouseEnter={() => setHoveredItemId(item.id)}
      onMouseLeave={() => setHoveredItemId(null)}
    >
      <AiLoadingOverlay isLoading={aiProcessingItems.has(item.id)} />
      <div className="file-card-header">
        <span className="file-type-icon">
          {getFileIcon(item.media_format, item.media_mime_type, 'GRID')}
        </span>
        <span className="file-name" title={item.title}>
          {removeFileExtension(item.title, item.media_format)}
        </span>
        <AiStatusBadge user={user} item={item} />
        {isDownloadCenter ? (
          <Button
            type="primary"
            icon="download"
            size="large"
            shape="circle"
            style={{ marginLeft: '8px' }}
            loading={downloadingMediaId === item.id}
            onClick={e => {
              e.stopPropagation()
              handleDownload(item.id)
            }}
          ></Button>
        ) : (
          <div className="file-card-actions">
            <Dropdown
              overlay={
                <FileActionsMenu
                  item={item}
                  user={user}
                  orgUserList={orgUserList}
                  defaultQuery={defaultQuery}
                  userId={userId}
                  isSuperAdmin={isSuperAdmin}
                  isAdmin={isAdmin}
                  aiProcessingItems={aiProcessingItems}
                  onAction={onAction}
                  setVersionFile={setVersionFile}
                  setVersionModalVisible={setVersionModalVisible}
                  setManagePermissionsModalVisible={
                    setManagePermissionsModalVisible
                  }
                  setAuitModal={setAuitModal}
                  closeDropdown={() => setOpenDropdownId(null)}
                />
              }
              trigger={['click']}
              visible={openDropdownId === item.id}
              onVisibleChange={visible => {
                if (visible) {
                  setOpenDropdownId(item.id)
                } else {
                  setOpenDropdownId(null)
                }
              }}
            >
              <Button
                type="text"
                icon="ellipsis"
                size="small"
                className="filecard-action-btn"
                onClick={function(e) {
                  e.stopPropagation()
                }}
                onMouseDown={function(e) {
                  e.stopPropagation()
                }}
              />
            </Dropdown>
          </div>
        )}
      </div>

      {(() => {
        if (item.category === 'tips') {
          return (
            <div className="file-card-preview">
              <img
                src={Share_Shorts_Grid_View}
                alt={item.title}
                style={{
                  height: '63% !important',
                  width: '63% !important'
                }}
                className="filecard-image-preview"
                onError={e => (e.target.style.display = 'none')}
              />
              <span
                className="file-icon"
                style={{
                  position: 'absolute',
                  marginTop: '1.5em',
                  left: '5.7em'
                }}
              >
                {getFileIcon(
                  item.media_format,
                  item.media_mime_type,
                  'GRID',
                  item
                )}
              </span>
            </div>
          )
        } else {
          return (
            <div className="file-card-preview">
              {isImage(item) ? (
                <img
                  src={item.link}
                  alt={item.title}
                  className="filecard-image-preview"
                  onError={e => (e.target.style.display = 'none')}
                />
              ) : (
                <span className="file-icon">
                  {getFileIcon(
                    item.media_format,
                    item.media_mime_type,
                    'GRID',
                    item
                  )}
                </span>
              )}
            </div>
          )
        }
      })()}

      <div className="file-card-meta">
        <AntdTooltip
          title={
            item.creator && (item.creator.first_name || item.creator.last_name)
              ? `${item.creator.first_name || ''} ${item.creator.last_name ||
                  ''}`.trim() || 'N/A'
              : 'N/A'
          }
        >
          <span className="filecard-avatar-wrapper">
            {item.creator && item.creator.avatar ? (
              <img
                className="avatar filecard-avatar"
                src={item.creator.avatar}
                alt=""
                onError={function(e) {
                  e.target.style.display = 'none'
                  e.target.parentNode &&
                    (e.target.parentNode.style.background = '#e5e7eb')
                }}
              />
            ) : (
              <span className="filecard-avatar-fallback"></span>
            )}
          </span>
        </AntdTooltip>
        <span className="meta-info">
          <span className="date">
            {t('v4:last_edited')}{' '}
            {new Date(item.updated_at).toLocaleDateString()},{' '}
            {new Date(item.updated_at).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit'
            })}
          </span>
        </span>
      </div>
      {shouldShowCheckbox(item.id) && (
        <div className="file-card-checkbox">
          <input
            type="checkbox"
            checked={selectedItems.includes(item.id)}
            onClick={e => e.stopPropagation()}
            onChange={e => {
              const newSelection = e.target.checked
                ? [...selectedItems, item.id]
                : selectedItems.filter(id => id !== item.id)
              onSelectionChange && onSelectionChange(newSelection)
            }}
          />
        </div>
      )}
    </div>
  )
}

export default FileCard
